<div class="modal-header">
  <h4 class="modal-title" [ngClass]="variant != null ? 'text-' + variant : ''">
    @if (variant === 'warning') {
      <i class="far fa-exclamation-triangle me-1 text-warning"></i>
    }
    <span>{{ title | translate }}</span>
  </h4>
  <button class="btn-close" (click)="dismiss()" aria-label="Close" type="button"></button>
</div>

<div class="modal-body">
  <div [innerHTML]="content | translate"></div>
</div>

<div class="modal-footer">
  <button class="btn" [ngClass]="variant !== 'primary' ? 'btn-link' : 'btn-primary'" (click)="dismiss()">
    {{ 'button.close' | portalTranslate }}
  </button>
</div>
